import React, { useContext } from 'react';
import http from './http';

const SettingsContext = React.createContext();

let settings = null;
let settingsLoading = false;

const SettingsLoader = ({ children }) => {
  const loadSettings = () => {
    settingsLoading = true;
    return http('POST', '/settings').then(s => (settings = s));
  };

  if (!settingsLoading) {
    throw loadSettings();
  }

  return <SettingsContext.Provider value={settings}>{children}</SettingsContext.Provider>;
};

const useSettings = () => useContext(SettingsContext);

export { useSettings, SettingsLoader };
